import { dashboardConstants } from "./dashboardConstants";

export const dashboardReducer = (state = { rooms: [] }, action) => {
  switch (action.type) {
    case dashboardConstants.TICKETS_LIST_PROCESSING:
      return {
        ...state,
        ticketsProcessing: action.isProcessing
      };
    case dashboardConstants.TICKETS_LIST_SUCCESS:
      return {
        ...state,
        ticketsList: action.tickets
      };
    case dashboardConstants.INBOX_UNREAD_SUCCESS:
      return {
        ...state,
        mark: action.mark
      };
    case dashboardConstants.ROOMS_UNREAD_SUCCESS:
      return {
        ...state,
        rooms: action.rooms
      };
    case dashboardConstants.TOTAL_RECORDS_SUCCESS:
      return {
        ...state,
        totalRecords: action.totalRecords
      };
    case dashboardConstants.TICKETS_LIST_FAILURE:
      return {
        ...state,
        ticketsError: action.error
      };
    case dashboardConstants.COORDINATORS_LIST_PROCESSING:
      return {
        ...state,
        coordinatorsProcessing: action.isProcessing
      };
    case dashboardConstants.COORDINATORS_LIST_SUCCESS:
      return {
        ...state,
        coordinatorsList: action.coordinatorsList
      };
    case dashboardConstants.COORDINATORSLIST_FAILURE:
      return {
        ...state,
        coordinatorError: action.error
      };
    default:
      return state;
  }
};
